import clsx from "clsx";
import { FunctionComponent, useEffect, useState } from "react";

import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";
import { useAuth } from "@voxmedia/duet-context/context/auth-context";

import * as styles from "./SubscribeNav.css";

interface Props {
  subscribeStyles?: string;
  linkStyles?: string;
  subscribeText?: string;
  signInText?: string;
  leftIcon?: React.ReactElement;
  getLoginUrl?: () => string;
  getSubscribeUrl?: () => string;
  hideAccountLink?: boolean;
  hideSubscribeLink?: boolean;
  showSubscribeLinkFirst?: boolean;
}

const SubscribeNav: FunctionComponent<Props> = ({
  subscribeStyles,
  subscribeText = "Subscribe",
  signInText = "Sign In",
  linkStyles,
  leftIcon,
  getLoginUrl,
  getSubscribeUrl,
  hideAccountLink = false,
  hideSubscribeLink = false,
  showSubscribeLinkFirst = true,
}) => {
  const analytics = useAnalytics();
  const auth = useAuth();
  const isSubscribed = auth.user?.isEntitled;

  const [loginUrl, setLoginUrl] = useState<string>("/auth/login");
  const [subscribeUrl, setSubscribeUrl] = useState<string>(
    "/subscribe?itm_campaign=desktop-top-navigation-subscribe&itm_medium=site&itm_source=desktop-top-navigation",
  );
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    if (getLoginUrl) {
      setLoginUrl(getLoginUrl());
    } else {
      // need to run this in a hook because it uses window.location,
      // which is not available in SSR
      const returnPath = encodeURIComponent(window.location.pathname);
      setLoginUrl(`/auth/login?returnPath=${returnPath}`);
    }

    if (getSubscribeUrl) {
      setSubscribeUrl(getSubscribeUrl());
    }

    if (!auth.userLoading || auth.user) {
      setAuthLoading(false);
    }
  }, [auth, getLoginUrl, getSubscribeUrl]);

  const subscribeLink = !hideSubscribeLink && !isSubscribed && (
    <a
      className={clsx(styles.subscribeButton, subscribeStyles)}
      href={subscribeUrl}
      onClick={() => {
        analytics?.emit({
          event: "authentication",
          authentication: {
            method: "subscribe_top_navigation",
          },
        });
      }}
    >
      {subscribeText}
    </a>
  );

  return !authLoading ? (
    <div className={styles.container}>
      {showSubscribeLinkFirst && subscribeLink}
      {!hideAccountLink && (
        <>
          {!auth.user ? (
            <a
              href={loginUrl}
              className={clsx(styles.accountLink, linkStyles)}
              onClick={() => {
                analytics?.emit({
                  event: "authentication",
                  authentication: {
                    method: "sign_in_top_navigation",
                  },
                });
              }}
            >
              {leftIcon && leftIcon}
              <span className={styles.accountLinkText}>{signInText}</span>
            </a>
          ) : (
            <a
              href="/account/profile"
              className={clsx(styles.accountLink, linkStyles)}
            >
              {leftIcon && leftIcon}
              <span className={styles.accountLinkText}>Account</span>
            </a>
          )}
        </>
      )}
      {!showSubscribeLinkFirst && subscribeLink}
    </div>
  ) : null;
};

export default SubscribeNav;
